import classNames from 'classnames';
import React from 'react';
import Image from '../../../platformui/Image';
import LetterSlideLabelTooltip from '../labelTooltip';

const InformationSlide = ({
  heading,
  text,
  imageUrl,
  imageDescription,
  tooltipButtontext,
  tooltipText,
}) => {
  return (
    <div
      className={classNames({
        'c-letter-slide': true,
        'c-letter-slide__information-slide': true,
      })}
    >
      <div
        className={classNames({
          'c-letter-slide__scrollable': true,
          'c-letter-slide__scrollable--information-slide': true,
        })}
      >
        <div className="c-letter-slide__information-slide__text">
          <h2 className="c-letter-slide__heading">{heading}</h2>
          <p className="c-letter-slide--top__text">{text}</p>
          <LetterSlideLabelTooltip
            tooltipLinkText={tooltipButtontext}
            tooltipText={tooltipText}
          />
        </div>
        <div className="c-letter-slide__image">
          {imageUrl && <Image ImageUrl={imageUrl} Alt={imageDescription} />}
        </div>
      </div>
    </div>
  );
};

export default InformationSlide;
